import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
/** A basic input component supporting various styles.
 * @description Use this element directly wherever a pre-styled input is needed
 * or within a {@link DfInputDecoratorComponent} to prepend or append additional elements
 * within a common input border frame.
 */
@Component({
  selector: 'df-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DfTextInputComponent implements OnInit {
  // TODO: should think about making label mandatory, but need to consider an option
  // for an override if the label is handled in another way / needs to be styled differently
  @Input() public label: string = '';
  @Input() public placeholder: string = '';
  @Input() public name: string = '';
  @Input() public value: string = '';
  @Input() public ariaLabel: string = '';
  @Input() public disabled: boolean = false;
  @Input() public readonly: boolean = false;

  public get placeholderName() {
    return `df-placeholder-${this.name}`;
  }

  constructor() {}

  public ngOnInit() {}
}
